import React from "react";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { useParseRouteActions, useFetchData } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";

const EditAssignFundForm = ({ id }) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`loans/${id}/details`);
  const myForm = new BCFormController(data, { submitSuffix: "voting/assign-funds", clearSuffixesOnSubmit: [id], submitMethod: "PUT" });
  myForm.addCenteredGroup([
    myForm.getDisplayField("Borrower name", { name: "borrowerOrganization" }),
    myForm.getDisplayField("SPE Name", { name: "specialPurposeEntity" }),
    myForm.getDisplayField("Project Name", { name: "projectName" }),
    myForm.getDisplayField("Application #", { name: "applicationNumber" })
  ], { blankWidth: 2 });

  myForm.addCenteredGroup([
    myForm.getDropdownField("Fund", `voting/list-fund-orgs/${id}`, { name: "fundOrganizationId", required: true }),
    myForm.getInputField("id", { name: "id", value: data.loanId, isHidden: { fundOrganizationId: true }, isHiddenOperation: "notequal" })
  ]);
  return <LmsFormGenerator myForm={myForm} isLoading={isLoading} error={error} actions={[{ text: "Approve", action: "save-close" }, "close"]}/>;
};

export const VotingAssignFundsTable = () => {
  return <LmsTable
    actionButtons={["edit", "export"]}
    apiSuffix="voting/assign-funds"
    sortable={["Created On"]}
  />;
};

const LmsVotingAssignFunds = ({ ...props }) => {
  const { params = {}, history } = props;
  const { isEdit, isMainPage, isActionAllowed, id } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return <React.Fragment>
    {isMainPage && <VotingAssignFundsTable/>}
    {isEdit && <EditAssignFundForm id={id}/>}
  </React.Fragment>;
};

export default LmsVotingAssignFunds;